import { BORDER_RADIUS, COLORS, DEVICE_TYPE, SIZE } from "constants/variables";
import styled from "styled-components";

export const PartnerDetailsContainer = styled.div`
  display: flex;
  gap: ${SIZE.max24};
  padding: ${SIZE.max40};
  @media screen and (max-width: ${DEVICE_TYPE.mobileHeader}) {
    flex-direction: column;
    height: 100%;
    max-height: 90vh;
    overflow-y: scroll;
  }
`;

export const PartnerDetailsIconContainer = styled.div`
  width: ${SIZE.max472};
  background-color: ${COLORS.Gunmetal};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${SIZE.max32};
  border-radius: ${BORDER_RADIUS.radius32};
  padding: ${SIZE.max40};
  @media screen and (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
  }
`;

export const PartnerDetailsIconWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const PartnerDetailsIcon = styled.img`
  width: ${SIZE.max160};
  background-position: center;
`;

export const PartnerDetailsIconTitle = styled.div`
  padding-inline: ${SIZE.max40};
  text-align: center;
`;

export const PartnerDetailsTextContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 704px;
  max-height: 536px;
  background-color: ${COLORS.Gunmetal};
  border-radius: ${BORDER_RADIUS.radius32};
  padding: ${SIZE.max40} 0 ${SIZE.max40} ${SIZE.max40};
  @media screen and (max-width: ${DEVICE_TYPE.mobileHeader}) {
    max-height: fit-content;
  }
`;

export const DescriptionWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-right: ${SIZE.max40};
`;
